export default [
  {
    'name': 'Alabama',
    'abbreviation': 'AL',
    'displayName': 'Alabama (AL)'
  },
  {
    'name': 'Alaska',
    'abbreviation': 'AK',
    'displayName': 'Alaska (AK)'
  },
  {
    'name': 'American Samoa',
    'abbreviation': 'AS',
    'displayName': 'American Samoa (AS)'
  },
  {
    'name': 'Arizona',
    'abbreviation': 'AZ',
    'displayName': 'Arizona (AZ)'
  },
  {
    'name': 'Arkansas',
    'abbreviation': 'AR',
    'displayName': 'Arkansas (AR)'
  },
  {
    'name': 'California',
    'abbreviation': 'CA',
    'displayName': 'California (CA)'
  },
  {
    'name': 'Colorado',
    'abbreviation': 'CO',
    'displayName': 'Colorado (CO)'
  },
  {
    'name': 'Connecticut',
    'abbreviation': 'CT',
    'displayName': 'Connecticut (CT)'
  },
  {
    'name': 'Delaware',
    'abbreviation': 'DE',
    'displayName': 'Delaware (DE)'
  },
  {
    'name': 'District Of Columbia',
    'abbreviation': 'DC',
    'displayName': 'District Of Columbia (DC)'
  },
  {
    'name': 'Federated States Of Micronesia',
    'abbreviation': 'FM',
    'displayName': 'Federated States Of Micronesia (FM)'
  },
  {
    'name': 'Florida',
    'abbreviation': 'FL',
    'displayName': 'Florida (FL)'
  },
  {
    'name': 'Georgia',
    'abbreviation': 'GA',
    'displayName': 'Georgia (GA)'
  },
  {
    'name': 'Guam',
    'abbreviation': 'GU',
    'displayName': 'Guam (GU)'
  },
  {
    'name': 'Hawaii',
    'abbreviation': 'HI',
    'displayName': 'Hawaii (HI)'
  },
  {
    'name': 'Idaho',
    'abbreviation': 'ID',
    'displayName': 'Idaho (ID)'
  },
  {
    'name': 'Illinois',
    'abbreviation': 'IL',
    'displayName': 'Illinois (IL)'
  },
  {
    'name': 'Indiana',
    'abbreviation': 'IN',
    'displayName': 'Indiana (IN)'
  },
  {
    'name': 'Iowa',
    'abbreviation': 'IA',
    'displayName': 'Iowa (IA)'
  },
  {
    'name': 'Kansas',
    'abbreviation': 'KS',
    'displayName': 'Kansas (KS)'
  },
  {
    'name': 'Kentucky',
    'abbreviation': 'KY',
    'displayName': 'Kentucky (KY)'
  },
  {
    'name': 'Louisiana',
    'abbreviation': 'LA',
    'displayName': 'Louisiana (LA)'
  },
  {
    'name': 'Maine',
    'abbreviation': 'ME',
    'displayName': 'Maine (ME)'
  },
  {
    'name': 'Marshall Islands',
    'abbreviation': 'MH',
    'displayName': 'Marshall Islands (MH)'
  },
  {
    'name': 'Maryland',
    'abbreviation': 'MD',
    'displayName': 'Maryland (MD)'
  },
  {
    'name': 'Massachusetts',
    'abbreviation': 'MA',
    'displayName': 'Massachusetts (MA)'
  },
  {
    'name': 'Michigan',
    'abbreviation': 'MI',
    'displayName': 'Michigan (MI)'
  },
  {
    'name': 'Minnesota',
    'abbreviation': 'MN',
    'displayName': 'Minnesota (MN)'
  },
  {
    'name': 'Mississippi',
    'abbreviation': 'MS',
    'displayName': 'Mississippi (MS)'
  },
  {
    'name': 'Missouri',
    'abbreviation': 'MO',
    'displayName': 'Missouri (MO)'
  },
  {
    'name': 'Montana',
    'abbreviation': 'MT',
    'displayName': 'Montana (MT)'
  },
  {
    'name': 'Nebraska',
    'abbreviation': 'NE',
    'displayName': 'Nebraska (NE)'
  },
  {
    'name': 'Nevada',
    'abbreviation': 'NV',
    'displayName': 'Nevada (NV)'
  },
  {
    'name': 'New Hampshire',
    'abbreviation': 'NH',
    'displayName': 'New Hampshire (NH)'
  },
  {
    'name': 'New Jersey',
    'abbreviation': 'NJ',
    'displayName': 'New Jersey (NJ)'
  },
  {
    'name': 'New Mexico',
    'abbreviation': 'NM',
    'displayName': 'New Mexico (NM)'
  },
  {
    'name': 'New York',
    'abbreviation': 'NY',
    'displayName': 'New York (NY)'
  },
  {
    'name': 'North Carolina',
    'abbreviation': 'NC',
    'displayName': 'North Carolina (NC)'
  },
  {
    'name': 'North Dakota',
    'abbreviation': 'ND',
    'displayName': 'North Dakota (ND)'
  },
  {
    'name': 'Northern Mariana Islands',
    'abbreviation': 'MP',
    'displayName': 'Northern Mariana Islands (MP)'
  },
  {
    'name': 'Ohio',
    'abbreviation': 'OH',
    'displayName': 'Ohio (OH)'
  },
  {
    'name': 'Oklahoma',
    'abbreviation': 'OK',
    'displayName': 'Oklahoma (OK)'
  },
  {
    'name': 'Oregon',
    'abbreviation': 'OR',
    'displayName': 'Oregon (OR)'
  },
  {
    'name': 'Palau',
    'abbreviation': 'PW',
    'displayName': 'Palau (PW)'
  },
  {
    'name': 'Pennsylvania',
    'abbreviation': 'PA',
    'displayName': 'Pennsylvania (PA)'
  },
  {
    'name': 'Puerto Rico',
    'abbreviation': 'PR',
    'displayName': 'Puerto Rico (PR)'
  },
  {
    'name': 'Rhode Island',
    'abbreviation': 'RI',
    'displayName': 'Rhode Island (RI)'
  },
  {
    'name': 'South Carolina',
    'abbreviation': 'SC',
    'displayName': 'South Carolina (SC)'
  },
  {
    'name': 'South Dakota',
    'abbreviation': 'SD',
    'displayName': 'South Dakota (SD)'
  },
  {
    'name': 'Tennessee',
    'abbreviation': 'TN',
    'displayName': 'Tennessee (TN)'
  },
  {
    'name': 'Texas',
    'abbreviation': 'TX',
    'displayName': 'Texas (TX)'
  },
  {
    'name': 'Utah',
    'abbreviation': 'UT',
    'displayName': 'Utah (UT)'
  },
  {
    'name': 'Vermont',
    'abbreviation': 'VT',
    'displayName': 'Vermont (VT)'
  },
  {
    'name': 'Virgin Islands',
    'abbreviation': 'VI',
    'displayName': 'Virgin Islands (VI)'
  },
  {
    'name': 'Virginia',
    'abbreviation': 'VA',
    'displayName': 'Virginia (VA)'
  },
  {
    'name': 'Washington',
    'abbreviation': 'WA',
    'displayName': 'Washington (WA)'
  },
  {
    'name': 'West Virginia',
    'abbreviation': 'WV',
    'displayName': 'West Virginia (WV)'
  },
  {
    'name': 'Wisconsin',
    'abbreviation': 'WI',
    'displayName': 'Wisconsin (WI)'
  },
  {
    'name': 'Wyoming',
    'abbreviation': 'WY',
    'displayName': 'Wyoming (WY)'
  }
];